import "core-js/modules/es.function.name.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  style: {
    "font-weight": "bold"
  }
};
var _hoisted_2 = {
  class: "modal-content"
};
var _hoisted_3 = {
  class: "search-container d-flex fl-j-c fl-a-c"
};
var _hoisted_4 = ["placeholder"];
var _hoisted_5 = {
  class: "ticket-list-wrapper"
};
var _hoisted_6 = {
  class: "ticket-row"
};
var _hoisted_7 = {
  class: "ticket-name"
};
var _hoisted_8 = {
  style: {
    "font-weight": "bolder"
  }
};
var _hoisted_9 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "1rem"
  }
};
var _hoisted_10 = {
  style: {
    "font-weight": "700"
  }
};
var _hoisted_11 = {
  key: 0,
  class: "pss-timeslot"
};
var _hoisted_12 = {
  class: "ticket-row-right"
};
var _hoisted_13 = {
  class: "ticket-qty"
};
var _hoisted_14 = ["onUpdate:modelValue"];
var _hoisted_15 = {
  class: "max-btn"
};

var _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "divider"
}, null, -1);

var _hoisted_17 = {
  class: "dialog-footer"
};
var _hoisted_18 = {
  class: "apply-btns-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.modalVisibility,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.modalVisibility = $event;
    }),
    class: "promocode-campaigns-tickets-modal"
  }, {
    header: _withCtx(function (_ref) {
      var _ctx$promocodeData, _ctx$promocodeData2;

      var titleClass = _ref.titleClass;
      return [_createElementVNode("div", null, [_createElementVNode("h4", {
        class: _normalizeClass(titleClass),
        style: {
          "font-weight": "normal"
        }
      }, [_createTextVNode(_toDisplayString(_ctx.$t("promo-campaigns.select-items")) + " ", 1), _createElementVNode("span", _hoisted_1, _toDisplayString((_ctx$promocodeData = _ctx.promocodeData) === null || _ctx$promocodeData === void 0 ? void 0 : _ctx$promocodeData.name) + " " + _toDisplayString((_ctx$promocodeData2 = _ctx.promocodeData) === null || _ctx$promocodeData2 === void 0 ? void 0 : _ctx$promocodeData2.percentageValue) + "%", 1)], 2)])];
    }),
    footer: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_17, [_createVNode(_component_el_button, {
        onClick: _ctx.hideDialog,
        class: "booking-button"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
        }),
        _: 1
      }, 8, ["onClick"]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_button, {
        type: "primary",
        loading: _ctx.isapplyToAllLoading,
        disabled: _ctx.isapplyToSomeLoading,
        onClick: _ctx.applyToAllTickets,
        class: "apply-btn",
        "data-cy": "apply-to-all-btn"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.apply-to-all")), 1)];
        }),
        _: 1
      }, 8, ["loading", "disabled", "onClick"]), _createVNode(_component_el_button, {
        type: "primary",
        loading: _ctx.isapplyToSomeLoading,
        disabled: _ctx.isapplyToAllLoading,
        onClick: _ctx.applyToSelectedTickets,
        class: "apply-btn"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.confirm")), 1)];
        }),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])])])];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("input", {
        class: "search-input",
        type: "search",
        placeholder: _ctx.$t('input.promocode-campaigns') + '...',
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _ctx.searchQuery = $event;
        })
      }, null, 8, _hoisted_4), [[_vModelText, _ctx.searchQuery]])]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedPSSList, function (pss) {
        return _openBlock(), _createElementBlock("div", {
          key: pss.index
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_8, _toDisplayString(pss.categoryName), 1), _createTextVNode(" | " + _toDisplayString(pss.pssType === _ctx.PSSType[_ctx.PSSType.Retail] ? _ctx.$t("promo-campaigns.retail") : _ctx.$t("promo-campaigns.ticket")) + " | " + _toDisplayString(pss.priceName), 1)]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTicketAppliedDiscountCodes(pss), function (line) {
          return _openBlock(), _createElementBlock("p", {
            class: "pss-applied-discounts",
            key: line.code
          }, [_createVNode(_component_SvgIcon, {
            iconContent: _ctx.CouponIcon,
            iconAlt: "",
            iconStyle: "width: 16px;\n                    height: 16px"
          }, null, 8, ["iconContent"]), _createTextVNode(" " + _toDisplayString(line.code) + " ", 1), _createElementVNode("span", _hoisted_10, "(" + _toDisplayString(line.percentage) + "%)", 1)]);
        }), 128))]), pss.pssType === _ctx.PSSType[_ctx.PSSType.Ticket] && pss.startDateTime ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.formatDateTime(pss.startDateTime)), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_button, {
          class: "qty-button",
          onClick: function onClick($event) {
            return _ctx.decrementPssCount(pss.index);
          }
        }, {
          default: _withCtx(function () {
            return [_createTextVNode("-")];
          }),
          _: 2
        }, 1032, ["onClick"]), _withDirectives(_createElementVNode("input", {
          type: "number",
          class: "qty-input",
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return _ctx.pssCount[pss.index] = $event;
          }
        }, null, 8, _hoisted_14), [[_vModelText, _ctx.pssCount[pss.index], void 0, {
          number: true
        }]]), _createVNode(_component_el_button, {
          class: "qty-button",
          onClick: function onClick($event) {
            return _ctx.incrementPssCount(pss.index);
          },
          disabled: _ctx.pssCount[pss.index] === pss.quantity
        }, {
          default: _withCtx(function () {
            return [_createTextVNode("+")];
          }),
          _: 2
        }, 1032, ["onClick", "disabled"])]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_button, {
          type: "primary",
          disabled: _ctx.pssCount[pss.index] === pss.quantity,
          onClick: function onClick($event) {
            return _ctx.setPssCount(pss.index, pss.quantity);
          }
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(" Max (x" + _toDisplayString(pss.quantity) + ") ", 1)];
          }),
          _: 2
        }, 1032, ["disabled", "onClick"])])])]), _hoisted_16]);
      }), 128))])])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}